import { useTranslation } from "react-i18next"

import ComingSoon from "@/components/shared/ComingSoon"

export const CommunicationHubComingSoon = () => {
  const { t } = useTranslation()
  return (
    <ComingSoon
      title={t("comingSoonRoutes.communicationHub.title")}
      description={t("comingSoonRoutes.communicationHub.description")}
      notifyMeButtonText={t("comingSoonRoutes.notifyMe")}
    />
  )
}
